// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/df6be0bfcf8af543a371.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5763eaf5b53c4e152955","129":"92fc1e9464086ba49168","130":"d5ff5d2296c57a2e6c50"}[chunkId] + ".chunk.js";
};